import React, { Component } from 'react';
import './DTCScanServiceButton.css';

import { Button, Icon } from 'antd';
import { inject, observer } from 'mobx-react';

import { Modal } from 'antd';

import moment from 'moment';

@inject('translationsStore', 'commonStore')
@observer
export default class DTCScanServiceButton extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (!!this.props.dtcscanService && !!this.props.dtcscanService.status && !!this.props.dtcscanService.created_at && !!this.props.dtcscanService.success) {
      const { status, created_at, success } = this.state.dtcscanService;
      this.setState({ status, created_at, success });
    }
  }

  static getDerivedStateFromProps(props, state) {
    let _state = null;
    if (!!props.dtcscanService && (props.dtcscanService.status !== state.status || props.dtcscanService.created_at !== state.created_at || props.dtcscanService.success !== state.success)) {
      _state = {
        ...state,
        status: props.dtcscanService.status,
        created_at: props.dtcscanService.created_at,
        success: props.dtcscanService.success,
      };
    }

    return _state;
  }

  onLaunchFullScan = () => {
    const { translationsStore } = this.props;
    Modal.confirm({
      title: translationsStore.translate(`carView.dtcscanservice.launch.confirm.title`),
      content: (
        <div>
          <div>{translationsStore.translate(`carView.dtcscanservice.launch.confirm.content`)}</div>
        </div>
      ),
      onOk: () => this.props.onLaunchFullScan()
    });
  };

  render() {
    const { translationsStore } = this.props;
    const { status, created_at } = this.state;
    let _thresholdExceeded = (!!status && status === "CREATED" && !!created_at && moment.duration(moment().diff(moment(created_at))).asMinutes() > 5);
    return (
      <div className="DTCScanServiceButton">
        <Button type="primary" onClick={this.onLaunchFullScan} className="slim" disabled={(!!status && status === "CREATED" && !_thresholdExceeded)}>
          {this.props.translationsStore.translate('carView.dtcscanservice.launch.buttonText')}
        </Button>
        {!!status && status === "CREATED" && !_thresholdExceeded && (
          <div className="inProgress">
            <Icon type="sync" spin />
          </div>
        )}
        {!(!status && status !== "CREATED") || _thresholdExceeded && (
          <div className="inProgress">
            <div>{translationsStore.translate(`carView.dtcscanservice.completed`)} {moment(created_at).format(commonStore.longDateFormat.L)} </div>
          </div>
        )}
      </div>
    );
  }
}
